import { render } from "./CalenderIcon.vue?vue&type=template&id=68b80d0d"
const script = {}
script.render = render

export default script